import { da, es } from 'date-fns/locale';
import { Row } from 'gridjs';
import { min } from 'lodash';
import * as XLSX from 'xlsx';
//import { quitarAcentos } from './Utils';
export const extractWorkbook = (event, setExcel, setLoader) => {
    //recibe un evento con un doc excel, lo procesa y asigna el wordbook y los nombres de las hojas
    if (event.target.files == 0) {
        setExcel({ workbook: undefined, hojass: [] });
        if (setLoader) setLoader(false);
        return;
    }

    const selectedFile = event.target.files[0];
    if (!selectedFile) {
        setExcel({ workbook: undefined, hojas: [] });
        if (setLoader) setLoader(false);
        return;
    }

    if (selectedFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        window.alert("Archivo no válido, solo se aceptan hojas de calculo Excel")
        setExcel({ workbook: undefined, hojas: [] });
        if (setLoader) setLoader(false);
        return;
    }

    const fileReader = new FileReader();
    fileReader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        setExcel({ workbook: workbook, hojas: workbook.SheetNames });
        if (setLoader) setLoader(false);
    };

    fileReader.readAsArrayBuffer(selectedFile);
}

export const extractWorkbookV2 = async (event) => {
    //recibe un evento con un doc excel, lo procesa y asigna el wordbook y los nombres de las hojas
    if (event.target.files == 0) {
        return { estatus: false, msj: "No se seleccionó ningún archivo", data: { workbook: undefined, hojas: [] } };
    }

    const selectedFile = event.target.files[0];
    if (!selectedFile) {
        return { estatus: false, msj: "No se seleccionó ningún archivo", data: { workbook: undefined, hojas: [] } };
    }

    if (selectedFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        return { estatus: false, msj: "Archivo no válido, solo se aceptan hojas de calculo Excel", data: { workbook: undefined, hojas: [] } };
    }

    try {
        const workbook = await readExcelFileAsync(selectedFile);
        const data = { workbook: workbook, hojas: workbook.SheetNames };
        return { estatus: true, msj: "Archivo procesado correctamente", data: data };
    } catch (error) {
        return { estatus: false, msj: "Error al procesar el archivo: " + error.message, data: { workbook: undefined, hojas: [] } };
    }
}

const readExcelFileAsync = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        fileReader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                resolve(workbook);
            } catch (error) {
                reject(error);
            }
        };

        fileReader.onerror = () => {
            reject(new Error('Error al leer el archivo'));
        };

        fileReader.readAsArrayBuffer(file);
    });
}

export const extraerJsonConDatos = async (workbook, hoja) => {
    if (!workbook || !hoja || hoja == "") return { estatus: false, msj: "No se proporcionó un libro de trabajo o una hoja válida", data: [] };

    const worksheet = workbook.Sheets[hoja];

    if (!worksheet) return { estatus: false, msj: "No se encontró la hoja especificada en el libro de trabajo", data: [] };

    const rawJsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    return { estatus: true, msj: "Datos extraídos correctamente", data: rawJsonData };
}

export const extractDataFromSheet = (excel, encabez, datos, setLoader, seccion) => {
    if (!excel.workbook || !excel.hoja || excel.hoja == "") {
        encabez([]);
        datos([]);
        if (setLoader) setLoader(false);
        return;
    }

    const worksheet = excel.workbook.Sheets[excel.hoja];
    if (!worksheet) {
        encabez([]);
        datos([]);
        if (setLoader) setLoader(false);
        return;
    }

    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });//extraeermos la información del documento

    var cleanData = []; //aquí guardaremos las entradas que nos son utiles
    var cabeceras = [];
    var cabeListas = false;
    jsonData.forEach(jsn => {
        if (!cabeListas && (cabeceras = verificarEncabezados(jsn)).length > 0) {
            cabeListas = true;
        } else if (!cabeListas) { }
        else if ((jsn ?? []).length == cabeceras.length) {
            let newClean = {};
            for (let i = 0; i < cabeceras.length; i++) { newClean[cabeceras[i]] = jsn[i] ?? ""; }
            cleanData.push(newClean);
        }
    });


    if (cabeceras.length > 0) {
        encabez(cabeceras);
        datos(cleanData);
        seccion({ section: 2, message: `Se encontraron ${cleanData.length} entradas de plan de siembra, pulse el botón debajo si desea agregarlas al sistema` });
    }
    else {
        encabez([]);
        datos([]);
        seccion({ section: 2, message: `No se encontró información útil en la hoja ${excel.hoja}` });
    }
    if (setLoader) setLoader(false);

    return;
}

const verificarEncabezados = (arreglo) => {
    let necesarios = [
        'color',
        'flor',
        'variedad',
        'talloscosecha',
        '#charolas',
        'plantas',
        'metrosnecesarios',
        'sem.necesaria',
        'semcampo',
        'germinacion',
        'semanatrasplante',
        'ciclocampo'];
    if (arreglo.length < 12) return [];
    let cabeceras = [];
    for (let i = 0; i < arreglo.length && necesarios.length > 0; i++) {
        let nombre = (arreglo[i] ?? "").toString();
        nombre = nombre.toLowerCase();
        nombre = nombre.replace(/\s/g, '');
        cabeceras.push(nombre);
        for (let j = 0; j < necesarios.length; j++) {
            let nec = necesarios[j];
            if (nec == nombre) {
                necesarios.splice(j, 1);
                j = necesarios.length + 200000;
            }
        }
    }

    if (necesarios.length == 0) return cabeceras;
    return [];
}

export const extractDataToArrayContpaq = (workbook, sheetName, setJsons, setCabeceras, setLoader, setPeriodoComtpaq) => {
    if (!workbook || !sheetName) {
        setJsons([]);
        setJsons([]);
        setCabeceras([]);
        setPeriodoComtpaq(null);
        if (setLoader) setLoader(false);
        return;
    }

    const worksheet = workbook.Sheets[sheetName];
    if (!worksheet) {
        window.alert("No se encontró información en la hoja seleccionada")
        setJsons([]);
        setCabeceras([]);
        setPeriodoComtpaq(null);
        if (setLoader) setLoader(false);
        return;
    }

    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    let periodoInicio, periodoFin;
    let encabezados;
    let cleanData = [];

    for (let i = 0; i < jsonData.length; i++) {
        var jsn = jsonData[i];
        if (!periodoInicio && !periodoFin) {
            //Primero buscamos el peroiodo del documento contpaq
            let periodo = extraerPeriodo(jsn);
            if (periodo && Array.isArray(periodo) && periodo.length == 2) {
                periodoInicio = periodo[0];
                periodoFin = periodo[1];
            }
        } else if (!encabezados) {
            //después buscamos los encabezados
            if (comprobarEncabezadosContpaq(jsn)) {
                encabezados = jsn;
            }
        } else if (jsn.length == encabezados.length) {
            //Capturamos todos los datos que correspondan con los encabezados
            if (comprobarRenglonDatosContpaq(jsn)) cleanData.push(jsn);
        }


    }

    if (cleanData.length == 0) {
        setJsons([]);
        setCabeceras([]);
        setPeriodoComtpaq(null);
        if (setLoader) setLoader(false);
        return;
    }

    setJsons(cleanData);
    setCabeceras(encabezados);
    setPeriodoComtpaq({ inicial: periodoInicio, final: periodoFin });
    if (setLoader) setLoader(false);
    return;
}

const comprobarRenglonDatosContpaq = (renglon) => {
    for (let i = 0; i < renglon.length; i++) {
        if (renglon[i] == null || renglon == undefined || renglon[i].toString().includes('---') || renglon[i] === '' || renglon[i] === ' ') return false;
    }


    return true;
}

const comprobarEncabezadosContpaq = (renglon) => {
    if (renglon.length < 20) return false;
    for (let i = 0; i < renglon.length; i++)
        if (!renglon[i] || !typeof renglon[i] == 'string' || renglon[i].includes('---') || renglon[i] == "") return false;
    return true;
}

const extraerPeriodo = (renglon) => {
    if (!Array.isArray(renglon) || renglon.length == 0) return false;

    const regexFecha = /\d{2}\/\d{2}\/\d{4}/g;
    let fechas;
    for (let i = 0; i < renglon.length; i++) {
        let value = renglon[i];
        if (renglon[i] &&
            typeof renglon[i] == 'string' &&
            renglon[i].toLowerCase().includes('periodo') &&
            (fechas = renglon[i].match(regexFecha)) != null) return fechas;
    }
    return false
}

const fechaNumeroExcel = (valorExcel) => {
    if (valorExcel === null || valorExcel === undefined) {
        return null; // Manejar el caso de valor nulo
    }

    // Convertir a valor Unix Timestamp (segundos desde el 1 de enero de 1970)
    var unixTimestamp = (valorExcel - 25569) * 86400; // 86400 segundos en un día

    // Crear un objeto de fecha en JavaScript
    var fecha = new Date(unixTimestamp * 1000); // Multiplicamos por 1000 porque JavaScript usa milisegundos

    // Obtener componentes de fecha (año, mes, día)
    var year = fecha.getFullYear();
    var month = String(fecha.getMonth() + 1).padStart(2, '0'); // Añadir cero inicial si es necesario
    var day = String(fecha.getDate()).padStart(2, '0'); // Añadir cero inicial si es necesario

    // Formatear la fecha como "YYYY-MM-DD"
    return `${year}-${month}-${day}`;
}

const esMetatdata = (array) => {
    const datosRequeridos = [
        'Uuid', 'RfcEmisor', 'NombreEmisor', 'RfcReceptor',
        'NombreReceptor', 'RfcPac', 'FechaEmision',
        'FechaCertificacionSat', 'Monto', 'EfectoComprobante', 'Estatus'
    ];

    for (const dato of datosRequeridos) {
        if (!array.includes(dato)) {
            return false;
        }
    }
    return true;
}

const anchoMaximo = (datos, index) => {
    let maximo = (index ?? "").toString().length;
    datos.forEach(element => {
        ;
        let dim = (element[index] ?? "").toString().length
        if (dim > maximo) maximo = dim;

    });
    return maximo + 1;
}

export const extraerDatosInventarioCampoExcel = async (excel) => {
    if (!excel.workbook || !excel.hoja || excel.hoja == "") return { 'encabezados': [], 'data': [] };

    const worksheet = excel.workbook.Sheets[excel.hoja];

    if (!worksheet) return { 'encabezados': [], 'data': [] };

    const rawJsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    const jsonData = eliminar_renglones_no_validos(rawJsonData, 20, [null, undefined]);//extraeermos la información del documento

    let index = 0;
    const analisiTitulos = extraerTitulosPlanCampo(jsonData);

    if (!analisiTitulos) return { 'encabezados': [], 'data': [] };

    const titulos = analisiTitulos.titulos.map(v => v.parseName);
    const hashTitulos = analisiTitulos.titulos;
    const dataLen = analisiTitulos.array.length;

    const dataResp = [];
    for (let i = index; i < dataLen; i++) {
        const resultAnalisis = extraerRenglonInventarioCampo(analisiTitulos.array[i], hashTitulos);
        if (!resultAnalisis) continue;
        dataResp.push(resultAnalisis);
    }
    return { 'encabezados': titulos, 'data': dataResp, 'tipo': 'campo' };
}

const extraerRenglonInventarioCampo = (row, hash) => {
    const jsonData = {};
    const rowLen = row.length;
    const len = hash.length;
    for (let i = 0; i < len; i++) {
        const index = hash[i].index;
        if (rowLen <= index) return false;
        if (hash[i].parseName === 'fecha_cosecha' || hash[i].parseName === 'fecha_siembra' || hash[i].parseName === 'fecha_trasplante') {
            jsonData[hash[i].parseName] = fechaNumeroExcel(row[index]);
        } else {
            jsonData[hash[i].parseName] = row[index];
        }
    }
    return jsonData;
}

const extraerTitulosPlanCampo = (json) => {
    const len = json.length;
    for (let i = 0; i < len; i++) {
        const row = json[i];
        const titulos = verificarTitulosPlanCampo(row);
        if (titulos) {
            return { titulos, array: json.slice(i + 1) }
        }
    }
    return null;
}

const verificarTitulosPlanCampo = (renglonDatos) => {
    /*
        ---------- datos del bloque
        'flor',
        'apellido',
        'color',
        ---------- datos de vivero
        'tip_siem',
        'dia_siem',
        'densidad',
        ---------- datos para itinerario camas,
        'mt2_siembra',
        'largo_cama',
        ---------- plan campo
        'sem_sie_campo',
        'dia_camp',
        'sem_corte',
        'fecha corte',
        'valvula',
        'seccion',
        'cama_inicio',
        'cama_final',
        'largo_cama',
        '#_plantas',
        ---------- para saber si es desde siembra directa
        'dias vivero',
        ---------- datos inventario vampo v2
        'numero inicio de tunel',
        'numero final de tunel',
        'germinacion',
        'ciclo',
        '#pl. con dec',
        '#_tallos',
        ---------- Datos de conteo
        'conteo plantas (3)',
        'conteo de tallo (6)',
        'conteo virus',
        ---------- Otros datos para ser inferidos
        'camaxvalvula',
        'largo_cama',
        'grados dia trasplante'
    */
    const hash = {
        "flor": { index: -1, parseName: "flor" },
        "apellido": { index: -1, parseName: "variedad" },
        "color": { index: -1, parseName: "color" },
        "tip_siem": { index: -1, parseName: "semana_siembra" },
        "dia_siem": { index: -1, parseName: "dia_siembra" },
        "densidad": { index: -1, parseName: "densidad" },
        "mt2_siembra": { index: -1, parseName: "metros2_siembra" },
        "largo_cama": { index: -1, parseName: "largo_cama" },
        "sem_sie_campo": { index: -1, parseName: "semana_trasplante" },
        "dia_camp": { index: -1, parseName: "dia_trasplante" },
        "sem_corte": { index: -1, parseName: "semana_cosecha" },
        "fecha corte": { index: -1, parseName: "fecha_cosecha" },
        "valvula": { index: -1, parseName: "valvula" },
        "seccion": { index: -1, parseName: "rancho" },
        "cama_inicio": { index: -1, parseName: "cama_inicio" },
        "cama_final": { index: -1, parseName: "cama_fin" },
        "#_plantas": { index: -1, parseName: "plantas_presupuesto" },
        "dias vivero": { index: -1, parseName: "dias_vivero" },
        "numero inicio de tunel": { index: -1, parseName: "tunel_inicio" },
        "numero final de tunel": { index: -1, parseName: "tunel_fin" },
        "germinacion": { index: -1, parseName: "germinacion" },
        "ciclo": { index: -1, parseName: "ciclo_campo" },
        "#pl. con dec": { index: -1, parseName: "numero_plantas" },
        "#_tallos": { index: -1, parseName: "tallos_recuperados" },
        "conteo plantas (3)": { index: -1, parseName: "conteo_plantas" },
        "conteo de tallo (6)": { index: -1, parseName: "conteo_tallos" },
        "conteo virus": { index: -1, parseName: "perdidas" },
        "camaxvalvula": { index: -1, parseName: "camas_por_valvula" },
        "grados dia trasplante": { index: -1, parseName: "grados_dia_desde_trasplante" },
        "etiqueta": { index: -1, parseName: "num_etiqueta" }
    };

    const lenNecesarios = 32;
    const lenRenglon = renglonDatos.length;
    if (lenRenglon < lenNecesarios) return null;

    renglonDatos = renglonDatos.map(item => (item ?? "").toString().toLowerCase());
    for (let i = 0; i < lenRenglon; i++) {
        const word = `${(renglonDatos[i] ?? "")}`;
        if (!hash.hasOwnProperty(word)) continue;
        hash[word].index = i;
    }

    if (Object.values(hash).some(v => v.index === -1)) return null;

    return Object.values(hash);

}


//elimina renglones de una matriz que no contienen la cantidad de columnas esperadas, no admitidos es un array con los calores que no se deben permitir en un renglón,
//los no admitidos se contabilizan por elemento del array, asi si un rengon tiene 20 valores pero 15 son no admitidos se tendran un total de 5 valores validos que se comparan
//con el minLen
const eliminar_renglones_no_validos = (data, minLen = 0, noAdmitidos = false) => {
    if (!Array.isArray(data)) return [];
    let clean = [];
    let len = data.length
    for (let i = 0; i < len; i++) {
        if (!Array.isArray(data[i])) continue;
        let rowlen = data[i].length;
        if (rowlen < minLen) continue;

        if (noAdmitidos) {
            let total_columnas = rowlen;
            for (let j = 0; j < total_columnas; j++) {
                if (noAdmitidos.includes(data[i][j])) rowlen--;
                if (rowlen < minLen) break;
            }
        }
        if (rowlen >= minLen) clean.push(data[i]);
    }
    return clean;
}

const extraerRelaciones = (i, data, headers) => {
    let tipos = { 'area': 'string', 'tarea': 'string', 'codigo_tarea': 'int', 'unidad': 'string', 'unidad_hora': 'float' }
    let dataJson = [];
    for (i; i < data.length; i++) {
        if (data[i].length < headers.length) continue;
        let dat = {};
        for (let j = 0; j < headers.length; j++) {
            let name = headers[j];
            let tipo = tipos[name];

            if (tipo === 'string') dat[name] = ((`${data[i][j] ?? ""}`).toLowerCase());
            else {
                let num = data[i][j];
                if (tipo === 'int') num = parseInt(data[i][j] ?? "dger");
                else num = parseFloat(data[i][j] ?? "dger");

                if (isNaN(num)) dat[name] = 0;
                else dat[name] = num;
            }
        }
        dataJson.push(dat);
    }
    return { 'encabezados': headers ?? [], 'data': dataJson, tipo: 'relaciones' };
}

const extraerDatosPlanCampo = (i, jsonData, headList, headsIndex) => {
    let dataJson = []; //datos extraidos
    let libres = []; //Entradas cuya flor es 99 lo que indica que esa cama está libre
    let fechas = ["fecha siembra", "fecha trasplante", "fecha t 2021", "fecha corte"];
    for (i; i < jsonData.length; i++) {
        let rowLen = jsonData[i].length;
        if (rowLen === 0) continue;
        let newData = {};
        let esLibre = false;

        for (let j = 0; j < headsIndex.length; j++) {
            let k = headsIndex[j];
            let jsonKey = headList[j];

            let jsonValue = (k + 1) >= rowLen ? undefined : jsonData[i][k];
            if (fechas.includes(headList[k]) && jsonValue) jsonValue = fechaNumeroExcel(jsonValue);
            newData[jsonKey] = jsonValue;
            if (headList[k] === 'flor') {
                if (`${jsonValue ?? ''}` === '99') esLibre = true;
                if (!jsonValue) jsonValue = 'null';
            }
        }

        if (!esLibre) dataJson.push(newData);
        else libres.push(newData);
    }
    return { 'encabezados': headList ?? [], 'data': dataJson, 'libres': libres, tipo: 'campo' };
}


const verificarPlanORelaciones = (row) => {
    let resp = encabezadosRelaciones(row);
    if (resp && resp.length > 0) return { tipo: 'relaciones', data: resp };

    resp = renglonContieneTitulosCampoNecesarios(row);
    if (resp) return { tipo: 'campo', data: resp };

    return { tipo: '', data: undefined }
}

const encabezadosRelaciones = (row) => {
    let necesarios = ['area', 'tarea', 'codigo_tarea', 'unidad', 'unidad_hora'];
    let encontrados = [];
    for (let i = 0; i < row.length; i++) {
        let char = (`${row[i] ?? ''}`).toLowerCase();
        char = char.replace(/[ /]/g, "_");
        if (necesarios.includes(char) && !encontrados.includes(char)) encontrados.push(char);
    }
    if (necesarios.length === encontrados.length) return encontrados;
    return [];
}

const renglonContieneTitulosCampoNecesarios = (row) => {

    let extractslist = [
        "#_tallos",
        "conteo plantas (3)",
        "conteo de tallo (6)",
        "#pl. con dec",
        "# de tallos con dec.",
        "riego",
        "tiempo de riego",
        "tunel",
        "n",
        "luz",
        "hoops",
        "r.o.",
        "sin/r.o.",
        "as",
        "pcodigo",
        "etiqueta",
        "seccion",
        "fecha siembra",
        "tip_siem",
        "dia_siem",
        "fecha trasplante",
        "fecha t 2021",
        "sem_sie_campo",
        "dia_camp",
        "dias vivero",
        "flor",
        "apellido",
        "color",
        "valvula",
        "formula",
        "camaxvalvula",
        "ttl_camas",
        "cama_inicio",
        "cama_final",
        "largo_cama",
        "densidad",
        "mt2_siembra",
        "ciclo",
        "fecha corte",
        "sem_corte",
        "dias hoy",
        "dias a corte",
        "dias corte",
        "grados dia trasplante",
        "gd 2021",
        "germinacion",
        "#_plantas",
        "talloxplanta",
        "conteo virus",
        "# de tunel"
    ];

    const lowerRow = row.map(item => (item ?? "").toString().toLowerCase());
    const rowlen = lowerRow.length;

    if (rowlen < extractslist.length) return null;
    let list = [];
    let index = [];

    for (let i = 0; i < rowlen; i++) {
        let word = `${(lowerRow[i] ?? "")}`;
        word = word.toLowerCase();
        if (extractslist.includes(word)) {
            list.push(word);
            index.push(i);
        }
    }
    console.log("verificando", index.length, extractslist.length, index.length < extractslist.length, (extractslist.length - 2) > index.length);
    if ((extractslist.length - 2) > index.length) return null;
    return { 'list': list, 'index': index };
}

export const generarExcel = (datos, titulo) => {

    let plano = quitarAcentos((titulo ?? "Sin titulo").toString());
    if (plano.length > 30) plano = plano.substring(0, 30);
    let anchos = [];
    if (datos.length > 0) {
        let keys = Object.keys(datos[0]);
        for (let i = 0; i < keys.length; i++) {
            let maxName = anchoMaximo(datos, keys[i]);
            anchos.push({ wch: maxName });
        }
    }

    const worksheet = XLSX.utils.json_to_sheet(datos);
    worksheet["!cols"] = anchos;

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, plano);
    XLSX.writeFile(workbook, `${plano}.xlsx`);
}

export function quitarAcentos(texto) {
    const acentos = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U",
        ä: "a",
        Ä: "A",
        ë: "e",
        Ë: "E",
        ï: "i",
        Ï: "I",
        ö: "o",
        Ö: "O",
        ü: "u",
        Ü: "U",
        ñ: "n",
        Ñ: "N",
    };

    // Reemplazar letras con acentos o caracteres especiales
    texto = texto.replace(/[áéíóúÁÉÍÓÚäÄëËïÏöÖüÜñÑ]/g, (match) => acentos[match] || match);

    // Eliminar caracteres no alfanuméricos
    texto = texto.replace(/[^\w_]/g, "");

    return texto;
}
